import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBasket2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="basket-2, shopping-bag"><path d="M8.25 3.75L6.35 8.5M15.75 3.75L17.65 8.5M21.25 8.75L19.25 20.25H4.75L2.75 8.75H21.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBasket2;
